import { ThreeDMarquee } from "../Effects/3DMarquee";
import { AnimatedButton } from "../Effects/AnimatedButton";
import { useNavigate } from "react-router-dom";

import img1 from "../assets/TeamBuilding/CubeStacking.jpg";
import img2 from "../assets/TeamBuilding/Buildingthetower.png";
import img3 from "../assets/TeamBuilding/CROSSTHERIVER.webp";
import img4 from "../assets/TeamBuilding/CUPandHOOPrace.png";
import img5 from "../assets/TeamBuilding/GoldMine.webp";
import img6 from "../assets/TeamBuilding/Knot.webp";
import img7 from "../assets/TeamBuilding/MYSTERIOUSCASE.webp";
import img8 from "../assets/TeamBuilding/RUGANDBALL.webp";
import img9 from "../assets/TeamBuilding/TugOfWar.webp";
import img10 from "../assets/TeamBuilding/SquaresGame.webp";
import img11 from "../assets/TeamBuilding/TREASUREHUNT.webp";
import img12 from "../assets/TeamBuilding/TeamMaze.png";
import img13 from "../assets/TeamBuilding/TheCage.png";
import img14 from "../assets/TeamBuilding/arranging.png";
import img15 from "../assets/TeamBuilding/WALKINGBOARDS.webp";
import img16 from "../assets/TeamBuilding/arranging.png";

import img17 from "../assets/Games/nintendo.webp";
import img18 from "../assets/Games/ps5.webp";
import img19 from "../assets/Games/racing.jpg";
import img20 from "../assets/Games/vr1.jpg";
import img21 from "../assets/Games/nintendo.webp";
import img22 from "../assets/Games/ps55.avif";
import img23 from "../assets/Games/vr2.webp";
import img24 from "../assets/Games/nintendo2.avif";
import img25 from "../assets/Games/vr3.jpg";




export function ThreeDMarqueeDemoSecond() {
  const navigate = useNavigate();

  const images = [
    img1, img2, img3, img4, img5, img17, img7, img8,
    img9, img10, img11, img12, img18, img14, img15, img16,
    img17, img18, img19, img20, img21, img22, img23, img24,
    img9, img10, img11, img12, img20, img14, img15, img16,
    img25, img2, img3, img4, img24, img6, img7, img13,

  ];

  const handleClick = () => {
    
    navigate("/team");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-white text-white">
      {/* Overlay to darken background images */}
      <div className="absolute inset-0 z-10 bg-black/80 dark:bg-black/60" />

      {/* Header Section */}
      <div className="relative z-20 text-center px-6">
        <h2 className="mx-auto max-w-4xl text-5xl font-bebas  text-white md:text-5xl lg:text-7xl">
        Team Building & Video Games
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-neutral-200 md:text-lg">
          Bring your team closer, spark creativity, and build trust with our curated
          team-building experiences. From problem-solving challenges to fun physical
          activities, we have something for every group.
        </p>
      </div>

      {/* Button to navigate to Rent Items page */}
      <div className="relative z-20 mt-8">
        <AnimatedButton
          text="Explore"
          onClick={handleClick}
        />
      </div>

      {/* 3D Marquee Effect */}
      <ThreeDMarquee
        className="pointer-events-none absolute inset-0 h-full w-full"
        images={images}
      />
    </div>
  );
}
